export enum AbcAnalysisSegmentLabel {
  A = 'Spitzenreiter',
  B = 'Wichtig',
  C = 'Mittel',
  D = 'Gering',
  E = 'Ohne Umsatz',
  F = 'Negativ / Retoure',
}

export function resolveSegmentLabel(segment: string): string {
  return (
    AbcAnalysisSegmentLabel[segment as keyof typeof AbcAnalysisSegmentLabel] ?? segment
  );
}
